var Utils = require("./utils");
var queryArray = Utils.queryArray;

var form = document.querySelector("form.form");
var formId = form && form.id;
var formAlert = document.getElementById("alert");
if (formAlert) formAlert.innerHTML = "";

var emailLabelOptions = [
  { value: "main", text: "main" },
  { value: "secondary", text: "secondary" },
];
var phoneLabelOptions = [
  { value: "main", text: "main" },
  { value: "secondary", text: "secondary" },
  { value: "corporate", text: "corporate" },
  { value: "fax", text: "fax" },
];
var urlLabelOptions = [
  { value: "main", text: "main" },
  { value: "secondary", text: "secondary" },
];

function uploadFile(file) {
  const formData = new FormData();
  formData.append(
    "query",
    "mutation UploadFiles($files: [Upload!]) { uploadFiles(files: $files) { id } }"
  );
  formData.append("variables", JSON.stringify({ files: ["file.0"] }));
  formData.append("file.0", file);
  return fetch(apiEndpoint, {
    method: "POST",
    body: formData,
  })
    .then(function (response) {
      if (response.ok) {
        return response.json();
      } else {
        return null;
        // You got problems
      }
    })
    .then(function (response) {
      if (
        response &&
        response.data &&
        response.data.uploadFiles &&
        Array.isArray(response.data.uploadFiles)
      ) {
        return response.data.uploadFiles[0].id;
      }
    })
    .catch(function () {
      return null;
    });
}

function initializeSelectizeFields() {
  $(function () {
    try {
      var labelInputs = queryArray("input.label");
      labelInputs.forEach(function (labelInput) {
        var value = [labelInput.value];
        var options = labelInput.classList.contains("url")
          ? urlLabelOptions
          : labelInput.classList.contains("phoneNumber")
          ? phoneLabelOptions
          : emailLabelOptions;
        $(labelInput).selectize({
          maxItems: 1,
          persist: false,
          options: options,
          items: value,
          create: function (input) {
            return {
              value: input,
              text: input,
            };
          },
        });
      });
    } catch (err) {
      console.log("No contact labels on this page's form.");
    }
    try {
      $("#buyersGuideCategories").selectize({
        options: buyersGuideCategoriesOpts.options,
        optgroups: buyersGuideCategoriesOpts.optgroups,
        maxItems: null,
        placeholder:
          "Click to select all categories you would like to display in the Buyer's Guide.",
      });
      if (formId != "member-app") {
        document
          .getElementById("buyersGuideCategories")
          .selectize.setValue(buyersGuideCategories, true);
      }
    } catch (err) {
      console.log("No BG Category field on this page's form.");
    }
    try {
      $("#contactGroups").selectize({
        options: contactGroupsOpts,
        maxItems: null,
        placeholder:
          "Click to select all contact groups you would like for this contact.",
      });
    } catch (err) {
      console.log("No Contact Group field on this page's form.");
    }
    try {
      $("#primaryContactContactGroups").selectize({
        options: contactGroupsOpts,
        maxItems: null,
        placeholder:
          "Click to select all contact groups you would like for this contact.",
      });
    } catch (err) {
      console.log("No Contact Group field on this page's form.");
    }
    try {
      $("#secondaryContactContactGroups").selectize({
        options: contactGroupsOpts,
        maxItems: null,
        placeholder:
          "Click to select all contact groups you would like for this contact.",
      });
    } catch (err) {
      console.log("No Contact Group field on this page's form.");
    }
    try {
      $("#categoryIds").selectize({
        options: categoryOpts,
        maxItems: null,
        onChange: window.achievementAwardHelpers.populateCategoryInfo,
        placeholder:
          "Click to select all categories for which your entry should be considered.",
      });
    } catch (err) {
      console.log("No Achievement Award categories on this page's form.");
    }
  });
}

function formButtonTimeOut(button) {
  setTimeout(function () {
    button.innerHTML = "Cannot Save";
    button.disabled = true;
    button.classList.add("invalid");
  }, 0);
}
function formButtonReset(button, text) {
  setTimeout(function () {
    button.innerHTML = text;
    button.disabled = false;
    button.classList.remove("invalid");
  }, 2000);
}

function addContactElement(type) {
  var list = document.querySelector(
    ".input-container[data-type='" + type + "']"
  );
  var row = document.createElement("div");
  row.classList.add("row");
  row.classList.add("contact-input");

  var wrapper1 = document.createElement("div");
  wrapper1.classList.add("wrapper");
  var wrapper2 = document.createElement("div");
  wrapper2.classList.add("wrapper");

  var labelLabel = document.createElement("label");
  labelLabel.innerHTML = "Label";
  var label = document.createElement("input");
  label.classList.add("label");
  label.classList.add(type);
  label.type = "text";
  wrapper1.appendChildChild(labelLabel);
  wrapper1.appendChild(label);

  var inputLabel = document.createElement("label");
  inputLabel.innerHTML = type;
  var input = document.createElement("input");
  input.classList.add(type);
  input.type = "text";
  wrapper2.appendChild(inputLabel);
  wrapper2.appendChild(input);

  var deleteLink = document.createElement("a");
  deleteLink.classList.add("delete-input");
  deleteLink.innerHTML = "Delete";
  // delete button confirms then deletes chosen item from lists
  deleteLink.addEventListener("click", function (e) {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete this item?")) {
      this.parentElement.remove();
    }
  });

  row.appendChild(wrapper1);
  row.appendChild(wrapper2);
  row.appendChild(deleteLink);
  list.appendChild(row);

  var options =
    type == "url"
      ? urlLabelOptions
      : type == "phoneNumber"
      ? phoneLabelOptions
      : emailLabelOptions;
  $(label).selectize({
    maxItems: 1,
    persist: false,
    options: options,
    create: function (input) {
      return {
        value: input,
        text: input,
      };
    },
  });
}

function updateToLocalStorage(formFields, currentTab, pages) {
  return Promise.all(
    formFields.map(function (input) {
      if (input.type == "checkbox") {
        return { name: input.id, data: input.checked };
      } else if (input.type == "file") {
        if (currentTab >= pages.length) {
          return formHelpers.uploadFile(input.files[0]).then(function (fileId) {
            if (fileId) return { name: input.id, data: fileId };
            return null;
          });
        }
      } else if (input.type == "select-multiple") {
        var options = [];
        $(input)
          .find("option:selected")
          .each(function () {
            options.push($(this).val());
          });
        return {
          name: input.id,
          data: options,
        };
      } else {
        return { name: input.id, data: input.value };
      }
    })
  )
    .then(function (formInput) {
      return formInput.filter(Boolean);
    })
    .then(function (formInput) {
      localStorage.setItem(formId, JSON.stringify(formInput));
    });
}

function updateFromLocalStorage(formInput) {
  try {
    formInput = JSON.parse(localStorage.getItem(formId));
    if (formInput && formInput.length) {
      formInput.forEach(function (dataItem) {
        var input = document.getElementById(dataItem.name);
        if (input.type == "checkbox") {
          input.checked = dataItem.data;
        } else if (input.type == "file") {
        } else if (input.type == "select-multiple") {
          $(function () {
            input.selectize.setValue(dataItem.data, true);
          });
        } else {
          input.value = dataItem.data;
        }
      });
    }
  } catch (err) {
    console.log(err);
  }
}

function createFormData(formFields, id) {
  var formFieldArray = Array.prototype.slice.call(formFields);
  if (
    id == "membership-renewal" ||
    id == "member-app" ||
    id == "member-edit" ||
    id == "achievement-award-app" ||
    id == "student-app"
  ) {
    return Promise.all(
      formFieldArray.map(function (input) {
        if (input.type == "checkbox")
          return { name: input.id, data: input.checked };
        else if (input.type == "file") {
          return formHelpers.uploadFile(input.files[0]).then(function (fileId) {
            console.log({ name: input.id, data: fileId });
            if (fileId) return { name: input.id, data: fileId };
            return { name: input.id, data: null };
          });
        } else if (input.type == "select-multiple") {
          var options = [];
          $(input)
            .find("option:selected")
            .each(function () {
              options.push($(this).val());
            });
          return {
            name: input.id,
            data: options,
          };
        } else return { name: input.id, data: input.value };
      })
    ).then(function (fields) {
      var formData = {};
      fields.forEach(function (field) {
        formData[field.name] = field.data;
      });
      return formData;
    });
  } else if (id == "settings-form") {
    var formData = new FormData();
    return Promise.all(
      formFieldArray.map(function (input) {
        if (input.type == "checkbox")
          return { name: input.id, data: input.checked };
        else if (input.type == "file")
          return formHelpers.uploadFile(input.files[0]).then(function (fileId) {
            if (fileId) return { name: input.id, data: fileId };
            return { name: input.id, data: null };
          });
        else if (input.type == "select-multiple") {
          var options = [];
          $(input)
            .find("option:selected")
            .each(function () {
              options.push($(this).val());
            });
          return {
            name: input.id,
            data: options,
          };
        } else return { name: input.id, data: input.value };
      })
    ).then(function (fields) {
      fields.forEach(function (field) {
        if (field.data) formData.append(field.name, field.data);
      });

      return formData;
    });
  } else {
    var formData = {};
    for (var i = 0; i < formFieldArray.length; i++) {
      var input = formFieldArray[i];
      if (input.type == "checkbox") {
        formData[input.name] = {
          name: input.getAttribute("data-name"),
          value:
            input.checked === false
              ? false
              : input.value
        };
      } else {
        formData[input.name] = {
          name: input.getAttribute("data-name"),
          value: input.value
        };
      }
    }
    return Promise.resolve(formData);
  }
}

function monetize(number) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol'}).format(number/100);
}

function populateRegistrationSummary(formFields) {
  var summary = document.getElementById("summary");
  summary.innerHTML = "";
  var guestField = document.getElementById("guest");
  var guestFields = [];
  var registrantFields = [];
  var eventFields = [];
  var fee = fees.memberFee;
  var member = true;

  formFields.map(function (field) {
    if (
      field.classList.contains("event") ||
      field.id == "guest" ||
      field.id == "registrationFee"
    ) {
      eventFields.push(field);
    } else if (field.id.toLowerCase().indexOf("guest") > -1) {
      if (field.id != "guest") {
        guestFields.push(field);
      }
    } else {
      if (field.id == "activeMember") {
        if (field.value == "true") {
          member = true;
          fee = fees.memberFee;
        } else {
          member = false;
          fee = fees.nonmemberFee;
        }
      } else if (field.id != "companyId") {
        registrantFields.push(field);
      }
    }
  });

  if (registrantFields && registrantFields.length) {
    var title = document.createElement("h4");
    title.innerHTML = "Registrant";
    var registrantTable = document.createElement("table");
    registrantTable.classList.add("fields");

    registrantFields.forEach(function (field) {
      var value = field.value;
      if (field.id != "contactId") {
        if (field.type == "checkbox") {
          value = field.checked ? "Yes" : "No";
        }
        registrantTable.innerHTML +=
          "<tr'><td>" +
          field.getAttribute("data-name") +
          "</td><td>" +
          value +
          "</td></tr>";
      }
    });
    summary.appendChild(title);
    summary.appendChild(registrantTable);
  }

  if (guestFields && guestFields.length && guestField.checked) {
    var title = document.createElement("h4");
    title.innerHTML = "Guest";
    var guestTable = document.createElement("table");
    guestTable.classList.add("fields");

    guestFields.forEach(function (field) {
      var value = field.value;
      if (field.type == "checkbox") {
        value = field.checked ? "Yes" : "No";
      }
      guestTable.innerHTML +=
        "<tr'><td>" +
        field.getAttribute("data-name") +
        "</td><td>" +
        value +
        "</td></tr>";
    });

    summary.appendChild(title);
    summary.appendChild(guestTable);
  }

  if (eventFields && eventFields.length) {
    var title = document.createElement("h4");
    title.innerHTML = "Events and Activitites";
    var eventsTable = document.createElement("table");
    eventsTable.classList.add("costs");

    const groupedFields = eventFields.reduce(function (acc, input) {
      const dataName = input.getAttribute("data-name") || input.name;
      acc[dataName] = acc[dataName] || [];
      acc[dataName].push(input);
      return acc;
    }, {});
    var totalDue = fee;
    var tr = document.createElement("tr");
    var td1 = document.createElement("td");
    td1.innerHTML = member ? "Member Registration Fee" : "Non-Member Registration Fee";
    var td2 = document.createElement("td");
    td2.innerHTML = monetize(fee) + "x 1<span>Registrant</span>";
    var td3 = document.createElement("td");
    td3.innerHTML = monetize(fee);
    tr.appendChild(td1);
    tr.appendChild(td2);
    tr.appendChild(td3);
    eventsTable.appendChild(tr);
    Object.keys(groupedFields).forEach(function (key) {
      var tr = document.createElement("tr");
      var td1 = document.createElement("td");
      var td2 = document.createElement("td");
      var td3 = document.createElement("td");
      td1.innerHTML = groupedFields[key][0].getAttribute("data-name");

      if (groupedFields[key].length && groupedFields[key].length > 1) {
        var guestBool =
          groupedFields[key][1].type == "checkbox"
            ? groupedFields[key][1].checked
            : groupedFields[key][1].value;
        var guestCost =
          (groupedFields[key][1].getAttribute("data-cost") &&
            parseInt(groupedFields[key][1].getAttribute("data-cost"))) ||
          0;
        var guestValue =
          groupedFields[key][1].type != "checkbox"
            ? " - " + groupedFields[key][1].value
            : "";
        var registrantBool =
          groupedFields[key][0].type == "checkbox"
            ? groupedFields[key][0].checked
            : groupedFields[key][0].value;
        var registrantCost =
          (groupedFields[key][0].getAttribute("data-cost") &&
            parseInt(groupedFields[key][0].getAttribute("data-cost"))) ||
          0;
        var registrantValue =
          groupedFields[key][0].type != "checkbox"
            ? " - " + groupedFields[key][0].value
            : "";

        totalDue += registrantBool ? parseInt(registrantCost) : 0;
        totalDue += guestBool ? parseInt(guestCost) : 0;

        if (
          registrantCost > 0 &&
          guestCost > 0 &&
          registrantCost == guestCost
        ) {
          var number =
            guestBool && registrantBool
              ? 2
              : !guestBool && !registrantBool
              ? 0
              : 1;
          var span =
            (guestBool ? "<span>Guest" + guestValue + "</span>" : "") +
            (registrantBool
              ? "<span>Registrant" + registrantValue + "</span>"
              : "");
          td2.innerHTML = monetize(registrantCost) + " x " + number + span;
          td3.innerHTML =
            registrantCost * number > 0
              ? monetize(registrantCost * number)
              : "";
        } else if (registrantCost == 0 && guestCost == 0) {
          var number =
            guestBool && registrantBool
              ? 2
              : !guestBool && !registrantBool
              ? 0
              : 1;
          var span =
            (guestBool ? "<span>Guest" + guestValue + "</span>" : "") +
            (registrantBool
              ? "<span>Registrant" + registrantValue + "</span>"
              : "");
          td2.innerHTML = "Complimentary x " + number + span;
        } else {
          var cost = registrantBool ? registrantCost : 0;
          cost += guestBool ? guestCost : 0;
          td1.innerHTML =
            groupedFields[key][0].getAttribute("data-name") +
            "<span>Registrant" +
            registrantValue +
            "</span><span>Guest" +
            guestValue +
            "</span>";
          td2.innerHTML =
            "<span><br />" +
            (registrantCost ? monetize(registrantCost) : "Complimentary") +
            " x " +
            (registrantBool ? "1" : "0") +
            "</span><span>" +
            (guestCost ? monetize(guestCost) : "Complimentary") +
            " x " +
            (guestBool ? "1" : "0") +
            "</span>";
          td3.innerHTML = monetize(cost);
        }
      } else {
        var cost =
          parseInt(groupedFields[key][0].getAttribute("data-cost")) || 0;
        var bool =
          groupedFields[key][0].type == "checkbox"
            ? groupedFields[key][0].checked
            : groupedFields[key][0].value;
        totalDue += bool ? cost : 0;

        td2.innerHTML =
          (cost > 0 ? monetize(cost) + " x " : "Complimentary x ") +
          (bool ? "1" : "0");
        td3.innerHTML = bool ? monetize(cost) : "";
      }
      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      eventsTable.appendChild(tr);
    });
    var totalDueRow =
      "<tr class='total'><td>Total Due</td><td /><td>" +
      monetize(totalDue) +
      "<td></tr>";
    eventsTable.innerHTML += totalDueRow;
    summary.appendChild(title);
    summary.appendChild(eventsTable);
  }
}

function newFieldsAddedListeners() {
  queryArray("a.delete-input").forEach(function (deleteLink) {
    deleteLink.addEventListener("click", function (e) {
      e.preventDefault();
      if (window.confirm("Are you sure you want to delete this item?")) {
        this.parentElement.remove();
      }
    });
  });
  queryArray("form.form input[type='number']").forEach(function (numberInput) {
    numberInput.addEventListener("keypress", function (e) {
      if (e.key.length === 1 && /\D/.test(e.key)) {
        e.preventDefault();
      }
    });
  });
  queryArray(".same-address").forEach(function (sameAddressField) {
    sameAddressField.addEventListener("change", function () {
      setRequired(
        ".address-block[data-type='" +
          sameAddressField.getAttribute("data-type") +
          "']",
        !sameAddressField.checked
      );
    });
  });
}

function setRequired(formBlock, bool) {
  if (bool) {
    document.querySelector(formBlock).classList.remove("hidden");
  } else {
    document.querySelector(formBlock).classList.add("hidden");
  }
}

function setUpPostalCodeListeners() {
  queryArray("select[data-type='country']").forEach(function (input) {
    input.addEventListener("change", function () {
      var fieldClass = input.getAttribute("data-class");
      var postalCodeField = document.querySelector("input[data-type='postalCode'][data-class='" + fieldClass + "']");
      if (input.value == "US") {
        postalCodeField.pattern = "^\\d{5}-\\d{4}$";
        postalCodeField.placeholder = "#####-####";
      } else {
        postalCodeField.removeAttribute("pattern");
        postalCodeField.placeholder = "#####";
      }
    });
  });
}

function setUpEmailAddressListeners() {
  queryArray("input[type='email']").forEach(function (input) {
    input.addEventListener("change", function () {
      console.log("here");
      input.value = input.value.toLowerCase();
    });
  });
}

window.formHelpers = {
  uploadFile: uploadFile,
  initializeSelectizeFields: initializeSelectizeFields,
  updateFromLocalStorage: updateFromLocalStorage,
  updateToLocalStorage: updateToLocalStorage,
  populateRegistrationSummary: populateRegistrationSummary,
  createFormData: createFormData,
  formButtonTimeOut: formButtonTimeOut,
  formButtonReset: formButtonReset,
  newFieldsAddedListeners: newFieldsAddedListeners,
  setUpPostalCodeListeners: setUpPostalCodeListeners,
  setUpEmailAddressListeners: setUpEmailAddressListeners,
};